module.exports = __webpack_public_path__ + "static/assets/78d500918bd3492bc1189be43483a6ae.png";